<template>
  <div class="border border-blue-100 flex flex-col mb-4 rounded-lg">
    <div v-if="!show">
      <div class="bg-seaweed-green-50 border-b border-blue-100 rounded-t-lg">
        <div class="flex items-center justify-between overflow-hidden">
          <div class="flex flex-grow items-center mr-4 overflow-hidden">
            <div class="menu-item-option-wrapper__view--name">
              <span
                :title="option.name"
                class="font-medium text-white truncate"
                >
                {{ option.name }}
              </span>
            </div>
            <menu-item-option-items-viewer
              :option-index="option.index"
              :option-items="option.items"
              @remove-item="removeItem"
            />
          </div>
          <div class="flex-grow-0 flex-shrink-0 mr-2">
            <w-button type="icon" @click="toggleShow(true)">
              <i class="icon-right-chevron" />
            </w-button>
          </div>
        </div>
      </div>
      <div class="px-2">
        <span class="text-gray-500 text-xs">
          {{ getOptionRulesWithNote(option.rules, option.storeNote) }}
        </span>
      </div>
    </div>
    <menu-item-option-editor
      v-else
      :option="option"
      @modify-option-with-items="modifyOptionWithItems"
      @remove-option="removeOption"
      @show="toggleShow"
    />
  </div>
</template>

<script>
import MenuItemOptionWrapper from './MenuItemOptionWrapper';

export default MenuItemOptionWrapper;
</script>

<style lang="scss" scoped>
@import 'MenuItemOptionWrapper';
</style>
